import React, { useEffect, useState } from 'react';
import './MealViewer.scss';
import axios from 'axios';
import { DateTime } from 'luxon';
import { Modal } from 'bootstrap';

const schoolsEnum = { 
    Penn: 'Penn', 
    NorthCentralJrHigh: 'North Central JR High', 
    LibertyHighSchool: 'North Liberty High School'
};

const MealViewer = () => {
    const [meals, setMeals] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState(0);
    const [schoolSelectedValue, setSchoolSelectedValue] = useState(schoolsEnum.Penn);
    const [numDaysSelectedValue, setNumDaysSelectedValue] = useState(1);
    const [mealModalContent, setMealModalContent] = useState({id: null, imageUrl: '', itemName: ''});

    const addDays = 10;

    useEffect(() => {
        const fetchMeals = async () => {
            setLoading(true);
            setError(null);
            try {
                const startDate = DateTime.now().toFormat("MM-dd-yyyy");
                const endDate = DateTime.now().plus({ days: numDaysSelectedValue }).toFormat("MM-dd-yyyy");
                const url = `https://api.mealviewer.com/api/v4/school/${schoolSelectedValue}/${startDate}/${endDate}/0`;
                const { data } = await axios.get(url);
                setMeals(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        
        fetchMeals();
    }, [schoolSelectedValue, numDaysSelectedValue]);

    const renderError = () => error && <p className="alert alert-danger">Error: {error}</p>;
    const renderLoading = () => loading && <><div className="spinner-grow text-secondary me-3" role="status"><span className="visually-hidden">Loading...</span></div><span className='h4 align-self-center'>Loading...</span></>;
    const renderNoMeals = () => !meals?.menuSchedules?.length && <p>No meals available.</p>;
    const mediaUrl = 'https://custcdn.mealviewer.com/';
    const foodImageUrl = mediaUrl + 'fooditemimages/';
    const schoolLogoUrl = mediaUrl + 'schoollogo/';
    // const schoolLogoUrl = schoolLogoMainUrl + meals?.physicalLocation?.schoolSettings?.schoolLogo !== '' ? schoolLogoMainUrl + meals?.physicalLocation?.schoolSettings?.schoolLogo : '';
    const schoolLogoMediaUrl = () => {
        return schoolLogoUrl + meals?.physicalLocation?.schoolSettings?.schoolLogo;
    }

    // console.log(schoolLogoMediaUrl);

    const Header = ({ schoolSelectedValue, numDaysSelectedValue, addDays, onSchoolChange, onDaysChange }) => (
        <div className='d-flex mb-4'>
            <h1 className='align-self-center flex-fill me-3' style={{color: `${meals?.physicalLocation?.schoolSettings?.schoolColor}`}}>
                <img src={schoolLogoMediaUrl()} height='50' alt={``} /> Meals</h1> {/*  ${meals?.physicalLocation?.name} logo */}
            <div>
                <div className='d-flex align-items-center mb-2'>
                    <label htmlFor="addDays" className='me-2 text-nowrap'>Add days</label>
                    <select id='addDays' className="form-select form-select-sm" onChange={onDaysChange} value={numDaysSelectedValue}>
                        {[...Array(addDays + 1).keys()].map((day) => (
                            <option key={day} value={day}>{day}</option>
                        ))}
                    </select>           
                </div>
                <div className='d-flex align-items-center'>
                    <label htmlFor="schoolSelection" className='me-2'>School</label>
                    <select id="schoolSelection" className="form-select form-select-sm" onChange={onSchoolChange} value={schoolSelectedValue}>
                        {Object.keys(schoolsEnum).map((key) => (
                            <option key={key} value={key}>
                                {schoolsEnum[key]}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    );
    
    const MealTabs = ({ meals, activeTab, onTabClick }) => (
        <nav>
            <div className="nav nav-tabs" role="tablist">
                {meals.map((schedule, index) => (
                    <MealTab key={index} schedule={schedule} isActive={index === activeTab} onClick={() => onTabClick(index)}/>
                ))}
            </div>
        </nav>
    );
    
    const MealTab = ({ schedule, isActive, onClick }) => {
        const dateFormatted = DateTime.fromISO(schedule.dateInformation.dateFull).toFormat('EEEE, MMM dd');
        const tabId = `nav-${DateTime.fromISO(schedule.dateInformation.dateFull).toFormat('EEEddyy')}`;
    
        return (
            <button style={{color: `${meals?.physicalLocation?.schoolSettings?.schoolColor}`}} className={`nav-link ${isActive ? 'active' : ''}`} id={`${tabId}-tab`} data-bs-toggle="tab" data-bs-target={`#${tabId}`} 
                type="button" role="tab" aria-controls={tabId} aria-selected={isActive} onClick={onClick}>
                    {dateFormatted}
            </button>
        );
    };
    
    const MealContent = ({ meals, activeTab }) => (
        <div className="tab-content">
            {meals.map((schedule, index) => (
                <MealBlock key={index} schedule={schedule} isActive={index === activeTab}/>
            ))}
        </div>
    );
    
    const MealBlock = ({ schedule, isActive }) => {
        const blockId = `nav-${DateTime.fromISO(schedule.dateInformation.dateFull).toFormat('EEEddyy')}`;
    
        return (
            <div className={`tab-pane fade ${isActive ? 'show active' : ''} p-3`} id={blockId} role="tabpanel" aria-labelledby={`${blockId}-tab`}>
                {schedule.menuBlocks?.length ? (
                    schedule.menuBlocks.map((line, idx) => (
                        <CafeteriaLine key={idx} line={line} />
                    ))
                ) : (
                    <p className="alert alert-info">No cafeteria lines available.</p>
                )}
            </div>
        );
    };

    const handleModalContent = (id, imageUrl, itemName) => {
        // const modalElement = document.getElementById(id);
        // const modal = Modal.getOrCreateInstance(modalElement);

        setMealModalContent({ id, imageUrl, itemName });

        // modal.show();
    }
    
    const CafeteriaLine = ({ line }) => {
        const { blockName, cafeteriaLineList } = line;
        const foodItems = cafeteriaLineList?.data?.[0]?.foodItemList?.data || [];
    
        return (
            <div>
                <h3 style={{color: `${meals?.physicalLocation?.schoolSettings?.schoolColor}`}}>{blockName}</h3>
                {foodItems.length ? (
                    <ul className="list-group mb-3">
                        {foodItems.map((meal, idx) => (
                            <li key={idx} className="list-group-item mb-1">
                                {meal.imageFileName && (
                                    <>
                                        <button className='btn btn-link' data-bs-toggle="modal" data-bs-target={`#mealModal${activeTab}`} onClick={() => handleModalContent(`mealModal${activeTab}`, `${foodImageUrl}${meal.imageFileName}`, meal.item_Name)}>
                                            <img src={`${foodImageUrl}${meal.imageFileName}`} width="200" alt={meal.item_Name} />
                                        </button>
                                        {/* <MealImageModal id={`mealModal${activeTab}`} imageUrl={`${foodImageUrl}${meal.imageFileName}`} itemName={meal.item_Name} /> */}
                                        <br />
                                    </>
                                )}
                                <span>{meal.item_Name}</span>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p>No food items available for this block.</p>
                )}
            </div>
        );
    };
    
    const MealImageModal = ({ id, imageUrl, itemName }) => (
        <div className={`modal fade`} id={id} tabIndex="-1" aria-labelledby={id} aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="staticBackdropLabel">{itemName}</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <img src={imageUrl} alt={itemName} className="img-fluid" />
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <>
        <section id={`${schoolsEnum.Penn}`}>
            {renderLoading() || (
                <>
                <Header schoolSelectedValue={schoolSelectedValue} numDaysSelectedValue={numDaysSelectedValue} addDays={addDays} onSchoolChange={(e) => setSchoolSelectedValue(e.target.value)} 
                    onDaysChange={(e) => setNumDaysSelectedValue(e.target.value)}/>
                {renderError() || renderNoMeals() || (
                    <>
                    <MealTabs meals={meals.menuSchedules} activeTab={activeTab} onTabClick={setActiveTab}/>
                    <MealContent meals={meals.menuSchedules} activeTab={activeTab}/>
                    </>
                )}
                </>
            )}
        </section>
        <MealImageModal 
            id={mealModalContent.id} 
            imageUrl={mealModalContent.imageUrl} 
            itemName={mealModalContent.itemName} 
        />
        </>
    );
};

export default MealViewer;
